import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { FcpButtonModule, FcpIconModuleSVG } from 'fc-ui-components';
import { SignupReferralStatusComponent } from './referral-status.component';

@NgModule({
    imports: [CommonModule, TranslateModule, FcpButtonModule, FcpIconModuleSVG],
    declarations: [SignupReferralStatusComponent],
    exports: [SignupReferralStatusComponent]
})
export class SignupReferralStatusModule {}
